// extracted by extract-css-chunks-webpack-plugin
module.exports = {"min-width-0":"_3X4Bwu","flex-shrink-0":"_1IJGmh"};